// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Container, Row,
} from 'react-bootstrap';
import { LinearProgress } from '@material-ui/core';
import StockStore from '../../stores/StockStore';
import DefaultTable from '../common/Tables/DefaultTable';
import AlertTemplate from '../common/AlertTemplate';

class StockApp extends Component {
  async componentDidMount() {
    try {
      await StockStore.loadItems(); // Load Products
    } catch (e) {
      console.log(e.message);
      StockStore.set('alert', {
        show: true,
        variant: 'danger',
        msg: `Error! ${e.message}`,
      });
    } finally {
      console.log('finally');
    }
  }

  render() {
    return (
      <Container>
        {StockStore.loading && <LinearProgress variant="query" />}
        <AlertTemplate alert={StockStore.alert} setShow={StockStore.set} />
        <Row >
          <h2> Test</h2>
         <DefaultTable items={StockStore.items} tableHead={StockStore.listHead}/>
        </Row>
      </Container>
    );
  }
}

export default observer(StockApp);
